// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"223":"92e2875d52bbd6a3c9cc","843":"8874610d6ee502945219"}[chunkId] + ".js";
};